/**
 * FAQSection - Frequently Asked Questions with Accordion
 * Features: Accessible accordion, animated on scroll
 */
import {
  Container,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { getFaqs } from "../constants/faqs";

const FAQSection = () => {
  const { t } = useTranslation();
  const faqs = getFaqs(t);

  return (
    <Box sx={{ bgcolor: "background.paper", py: 6 }}>
      <Container maxWidth="md">
        <Typography
          variant="overline"
          align="center"
          display="block"
          sx={{ color: "primary.main", fontWeight: 700, letterSpacing: "0.15em", mb: 1 }}
        >
          {t("home.faq.eyebrow")}
        </Typography>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.8rem", md: "2.2rem" },
            mb: 4,
            color: "text.primary",
          }}
        >
          {t("home.faq.title")}
        </Typography>
        {faqs.map((faq, index) => (
          <motion.div
            key={faq.id}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <Accordion
              sx={{
                mb: 2,
                "&:before": { display: "none" },
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`${faq.id}-content`}
                id={`${faq.id}-header`}
              >
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" color="text.secondary">
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </motion.div>
        ))}
      </Container>
    </Box>
  );
};

export default FAQSection;
